import * as React from "react";
import "./tabSetContent.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Indicates if tab content has white background.
	 */
	isWhite?: boolean;
}

export default class TabSetContent extends React.Component<IProps, {}> {

	render() {

		const classFromProps = classNames({
			"is-white": this.props.isWhite,
			"m-tab-set-content": true
		});

		return (
			<div className={classFromProps}>
				{this.props.children}
			</div>
		);
	}
}
